import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categorySelect", "supportSection"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isTermiaire = this.categorySelectTarget.value === "tertiaire"
    this.supportSectionTarget.classList.toggle("hidden", !isTermiaire)
  }
}
